jQuery(function ($) {
    'use strict';

    var currentScrollPosition = 0;

    var toggleMobileEditions = function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('top-nav-open');

        $('.shareBarBottom').toggle();
        $('.editions-mobile').toggle();
        $('.mobileweb_bottom_floating').toggle();
        //force closing left menu in case it's opened
        var $hamburgerMenu = $('.hamburger-nav-menu');

        var hamburgerOpened = $hamburgerMenu.hasClass('top-nav-open');
        var editionsOpened =$(this).hasClass('top-nav-open');

        $('body').toggleClass('mobile-menu-opened', hamburgerOpened || editionsOpened);

        if (hamburgerOpened && editionsOpened) {
            $hamburgerMenu.removeClass('hamburger-nav-open top-nav-open');
            $hamburgerMenu.addClass('hamburger-nav-closed');
            $('.mobile-menu', '.header--mobile').toggleClass('pane-open');
        }
    };

    var handleMobileMenuDisplay = function() {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > 50 && scrollTop > currentScrollPosition) {
            $('nav.mobile').addClass('hide');
        } else {
            $('nav.mobile').removeClass('hide');
        }

        currentScrollPosition = scrollTop;
    };


    $('.editions-nav-menu').off("click").click(toggleMobileEditions);

    $(window).scroll(handleMobileMenuDisplay);

    // mobile nav click-to-scroll-horizontally
    $('.pane-navigation-item').click(function(e) {
        e.preventDefault();

        //highlight current nav item
        $('.pane-navigation-item').removeClass('pane-navigation-item-current');
        $(this).addClass('pane-navigation-item-current');

        var panelCurrentOffset = $('.pane-list-container').scrollLeft();
        $('.pane-list-container').animate({scrollLeft: panelCurrentOffset + $($(this).parent().attr("href")).offset().left});
    });

});
